<div class="hub">
  <header class="hub__head">
    <h1>{{ 'support_hub.title' | translate }}</h1>
    <p>{{ 'support_hub.subtitle' | translate }}</p>
  </header>

  <div class="hub__ways">
    <a class="way" [routerLink]="['/', lang, 'health-concierge']" [queryParams]="{ new: 1 }">
      <span class="way__icon"><svg cIcon name="cilCompass" size="xl"></svg></span>
      <strong>{{ 'support_hub.question.title' | translate }}</strong>
      <span class="way__text">{{ 'support_hub.question.text' | translate }}</span>
      <span class="way__go">{{ 'support_hub.question.cta' | translate }} →</span>
    </a>

    <a class="way" [routerLink]="['/', lang, 'support', 'request']" [queryParams]="{ new: 1 }">
      <span class="way__icon"><svg cIcon name="cilSettings" size="xl"></svg></span>
      <strong>{{ 'support_hub.help.title' | translate }}</strong>
      <span class="way__text">{{ 'support_hub.help.text' | translate }}</span>
      <span class="way__go">{{ 'support_hub.help.cta' | translate }} →</span>
    </a>

    <a class="way" [routerLink]="['/', lang, 'support', 'requests']">
      <span class="way__icon"><svg cIcon name="cilList" size="xl"></svg></span>
      <strong>{{ 'support_hub.mine.title' | translate }}</strong>
      <span class="way__text">{{ 'support_hub.mine.text' | translate }}</span>
      <span class="way__go">{{ 'support_hub.mine.cta' | translate }} →</span>
    </a>
  </div>

  <p class="hub__foot">{{ 'support_hub.emergency' | translate }}</p>
</div>
